import React, { useState } from 'react';

function InfoBox({ content, icon = null, type, canClose = true, extraClass = '' }) {
	const [show, setShow] = useState(true);
	const icons = {
		danger: 'fas fa-exclamation-circle',
		info: 'fas fa-info-circle',
		success: 'fas fa-check-circle',
	};

	return (
		<>
			{show && (
				<div className={`myInfoBox myInfoBox-${type} ${extraClass} mb-4 rounded-4`}>
					<div className='d-flex justify-content-between'>
						<div className='d-flex align-items-center justify-content-between'>
							{icon || <i className={`me-3 fa-2x ${icons[type]}`}></i>}
							<span>{content}</span>
						</div>
						{canClose && (
							<i
								onClick={() => setShow(false)}
								className='hoverable fa-lg fas fa-times'></i>
						)}
					</div>
				</div>
			)}
		</>
	);
}

export default InfoBox;
